import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AcknowledgeDialogComponent } from '../../pages/acknowledge-dialog/acknowledge-dialog.component';
import { AuthService } from '../../services/auth.service';



@Component({
  selector: 'app-landing-layouts',
  templateUrl: './landing-layouts.component.html',
  styleUrls: ['./landing-layouts.component.scss']
})
export class LandingLayoutsComponent {
  constructor(private router: Router, private route: ActivatedRoute, private dialog: MatDialog, private auth: AuthService) { }

  ngOnInit(): void {
    this.checkEmailVerify();
  }

  isRootPath(): boolean {
    return /^\/(#.*)?$/.test(this.router.url);
  }

  checkEmailVerify(): void {
    this.route.queryParams.subscribe(params => {
      const error = params['error'];
      const errorDescription = params['error_description'];
      const autoLogin = params['autoLogin'];
      const autoSignup = params['autoSignup'];

      console.log('Error:', error);
      console.log('Error Description:', errorDescription);

      if (error === 'access_denied' && errorDescription === 'Please verify your email before logging in.') {
        console.log('Displaying email verification dialog'); // 添加调试日志
        this.dialog.open(AcknowledgeDialogComponent, {
          data:  'Please proceed to your mailbox to verify your email. Once completed, your account will be ready for login.'
          
        });
        this.router.navigate(['']);
      }

      // Optional: allow external sites to deep-link into login/signup on this landing page.
      // Example: https://rtk-expert.../?autoLogin=1
      if (!this.auth.isLoggedIn()) {
        if (String(autoLogin || '') === '1') {
          this.auth.login();
          return;
        }
        if (String(autoSignup || '') === '1') {
          this.auth.signup();
          return;
        }
      }
    });
  }

  isEmailVerify(): boolean {
    return this.router.url.includes("?error=access_denied&error_description=Please%20verify%20your%20email%20before%20logging%20in.");
  }
  
}
